import React from 'react';
import { Lock, Globe, Smartphone, DollarSign } from 'lucide-react';
import { getAllOfficialProductComparisonDataI18n } from '../config/officialProductComparisonDataI18n';
import { useTranslation } from 'react-i18next';

const OfficialProductComparison = ({ currentProductName }) => {
 const { t } = useTranslation();
 
 // 从配置文件获取所有官网产品数据（支持多语言）
 const products = getAllOfficialProductComparisonDataI18n();

 return (
 <div className="bg-gradient-to-b from-cream-100 to-cream-50 py-20">
 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
 <div className="text-center mb-16">
 <h2 className="text-4xl lg:text-5xl font-bold text-ink-900 mb-6">
 {t('productComparison.title')}
 </h2>
 <p className="text-xl text-ink-600 max-w-3xl mx-auto">
 {t('productComparison.subtitle')}
 </p>
 </div>

 <div className="bg-cream-50 rounded-xl shadow-md overflow-hidden border border-ink-100">
 <div className="overflow-x-auto">
 <table className="w-full text-sm">
 <thead>
 <tr className="bg-accent-500">
 <th className="text-left py-4 px-6 font-bold text-white text-base sticky left-0 bg-accent-500 z-10 min-w-[200px]">
 {t('productComparison.table.productName')}
 </th>
 <th className="text-center py-4 px-6 font-bold text-white text-base min-w-[200px]">
 {t('productComparison.table.loginMethod')}
 </th>
 <th className="text-center py-4 px-6 font-bold text-white text-base min-w-[180px]">
 {t('productComparison.table.dataPrivacy')}
 </th>
 <th className="text-center py-4 px-6 font-bold text-white text-base min-w-[150px]">
 {t('productComparison.table.price')}
 </th>
 <th className="text-center py-4 px-6 font-bold text-white text-base min-w-[150px]">
 {t('productComparison.table.officialPrice')}
 </th>
 </tr>
 </thead>
 <tbody>
 {products.map((product, index) => {
 const isRenewal = product.features?.isRenewal;
 const isShared = product.features?.sharedUsers > 1;
 const isEvenRow = index % 2 === 0;
 
 return (
 <tr 
 key={product.id}
 className={`
 border-b border-ink-100 transition-colors duration-300
 ${isRenewal ? 'hover:bg-green-50 bg-green-50' :
 isShared ? 'hover:bg-accent-50' : 'hover:bg-accent-50'}
 ${!isRenewal && !isShared && !isEvenRow ? 'bg-cream-50' : ''}
 `}
 >
 <td className={`py-4 px-6 font-semibold text-ink-800 sticky left-0 z-10 ${
 isRenewal ? 'bg-green-100' : 
 isShared ? 'bg-accent-50' :
 isEvenRow ? 'bg-cream-100' : 'bg-cream-50'
 }`}>
 <div>
 <div className="text-base font-bold">{t('productComparison.productName')}</div>
 <div className="text-sm text-ink-600 mt-1">{t(`productComparison.accountTypes.${product.id}`, product.type)}</div>
 </div>
 </td>
 <td className="py-4 px-6 text-center">
 <div className="flex flex-col items-center gap-2">
 <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-1">
 <Globe className="w-3 h-3 mr-1" />
 {t('productComparison.loginMethods.gptWebsite')}
 </span>
 <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700">
 <Smartphone className="w-3 h-3 mr-1" />
 {t('productComparison.loginMethods.appClient')}
 </span>
 </div>
 </td>
 <td className="py-4 px-6 text-center">
 <span className={`inline-flex items-center text-sm ${
 isShared ? 'text-accent-700' : 'text-green-700'
 }`}>
 <Lock className="w-3.5 h-3.5 mr-1" />
 {isShared 
 ? t('productComparison.privacy.sharedVisible')
 : t('productComparison.privacy.privateOnly')
 }
 </span>
 </td>
 <td className="py-4 px-6 text-center">
 <div className={`text-base font-bold ${
 isShared ? 'text-accent-700' : 
 isRenewal ? 'text-green-700' : 'text-accent-700'
 }`}>
 <span className="flex items-center justify-center">
 <DollarSign className="w-4 h-4" />
 {product.priceValue}
 </span>
 <div className="text-xs text-ink-500 mt-1">{t('productComparison.period.month')}</div>
 </div>
 </td>
 <td className="py-4 px-6 text-center">
 <span className="text-base font-semibold text-red-500">
 <span className="flex items-center justify-center">
 <DollarSign className="w-4 h-4" />
 {product.officialPriceValue}
 </span>
 <div className="text-xs text-ink-500 mt-1">{t('productComparison.period.month')}</div>
 </span>
 </td>
 </tr>
 );
 })}
 </tbody>
 </table>
 </div>
 </div>

 {/* 当前产品高亮提示 */}
 {currentProductName && (
 <div className="mt-6 text-center">
 <p 
 className="text-ink-600"
 dangerouslySetInnerHTML={{ 
 __html: t('productComparison.currentViewing', { productName: currentProductName })
 }}
 />
 </div>
 )}

 </div>
 </div>
 );
};

export default OfficialProductComparison;